




































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { VipCapabilityStatus } from "@/loader";
import CapabilitiesTable from "./CapabilitiesTable.vue";

let _id: number = 0;

@Component({
	components: {
		CapabilitiesTable,
	}
})
export default class CapabilitiesWidget extends Vue {
	@Prop({ type: String, default: null })
	public status!: VipCapabilityStatus | null;

	@Prop({ type: String, default: () => `capability_widget_${++_id}` })
	public id!: string;

	@Prop({ type: String, default: "Capacités" })
	public title!: string;

	@Prop({ type: String, default: null })
	public accordion!: string | null;

	@Prop({ type: Boolean, default: false })
	public visible!: boolean;

	@Prop({ type: Boolean, default: false })
	public possibilities!: boolean;

	@Prop({ type: Boolean, default: null })
	public expired!: boolean | null;

	@Prop({ type: Boolean, default: null })
	public renewable!: boolean | null;

	@Prop({ type: Boolean, default: null })
	public renewed!: boolean | null;

	@Prop({ type: [Number, String], default: 20 })
	public perPage!: number;

	@Ref()
	public table!: CapabilitiesTable;

	public totalRows: number = 0;

	public show() {
		this.$root.$emit("bv::toggle::collapse", this.id);
	}

	public setTotalRows(value: number) {
		this.totalRows = value;
	}

	public refresh() {
		this.table.refresh();
	}
}
